import clsx from "clsx";
import React from "react";
import ReactDOM from "react-dom";
const LoadingInstance = () => {
  return (
    <div className={clsx("loading-wrapper")}>
      <div className="loadingio-spinner-ellipsis-0e9htm6lpb7">
        <div className="ldio-tk8dyrglbc">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

class PlatFormLoading {
  timer = null;
  container = null;
  show(timeout) {
    this.clearTimeout();
    if (timeout) {
      this.timer = setTimeout(() => {
        this.hide();
      }, timeout);
    }
    const dom = document.createElement("div");
    this.container = dom;
    document.body.appendChild(dom);
    ReactDOM.render(<LoadingInstance />, dom);
  }
  hide() {
    this.clearTimeout();
    if (this.container) {
      try {
        ReactDOM.unmountComponentAtNode(this.container);
        this.container.remove();
      } catch (e) {
        console.warn(e);
      }
    }
  }
  clearTimeout() {
    clearTimeout(this.timer);
  }
}

export default new PlatFormLoading();
